import AuthInput from "./AuthInput"

export default AuthInput
